import { render, staticRenderFns } from "./PatientTable.vue?vue&type=template&id=4e44e2a8&scoped=true"
import script from "./PatientTable.vue?vue&type=script&lang=js"
export * from "./PatientTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e44e2a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e44e2a8')) {
      api.createRecord('4e44e2a8', component.options)
    } else {
      api.reload('4e44e2a8', component.options)
    }
    module.hot.accept("./PatientTable.vue?vue&type=template&id=4e44e2a8&scoped=true", function () {
      api.rerender('4e44e2a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/enroll/copm/PatientTable.vue"
export default component.exports